import { ReactNode, useState } from "react";
import { useParams } from "react-router-dom";
import BlankLayout from "src/materio/@core/layouts/BlankLayout";
import AccountConfirmation from 'src/features/users/views/AccountConfirmation';
import { confirmAccountApi } from 'src/configs/endpoints';
import { client } from 'src/utils/axios-client';
import { useNavigate } from 'react-router-dom';

const AccountConfirmationScreen = () => {
    let { token } = useParams();
    const navigate = useNavigate();
    const [error, setError] = useState(false);

    const onSubmit = async (email: string, password: string, confirmPassword: string) => {
        setError(false);

        try {
            const response = await client.post(confirmAccountApi, { email, password, confirmPassword, token });        

            if (!response.data.succeeded) {
                setError(true);
            } else {
                navigate('/login')
            }
        } catch (err) {
            setError(true);
        }        
    }

    return <AccountConfirmation onSubmit={onSubmit} hasError={error} />
}

AccountConfirmationScreen.getLayout = (page: ReactNode) => <BlankLayout>{page}</BlankLayout>

AccountConfirmationScreen.guestGuard = true;

export { AccountConfirmationScreen };
export default AccountConfirmationScreen;